export var configKeys = {
    detail: function (configType) { return [configType]; },
};
